import { render } from "./AiAuditTrend.vue?vue&type=template&id=506cf6b3&scoped=true"
import script from "./AiAuditTrend.vue?vue&type=script&lang=js"
export * from "./AiAuditTrend.vue?vue&type=script&lang=js"

import "./AiAuditTrend.vue?vue&type=style&index=0&id=506cf6b3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506cf6b3"]])

export default __exports__